import { allInOneCalculatorTrackingInitializer } from '../tracking/allInOneCalculatorTrackingInitializer';
import { formTrackingInitializer } from '../tracking/formsTrackingInitializer';
import { permissionCenterTrackingInitializer } from '../tracking/permissionCenterTrackingInitializer';
import { getComponentDomElements } from './reactComponentsInitializer';
const TrackingInitializerMap = {
    AllInOneCalculator: allInOneCalculatorTrackingInitializer,
    PermissionCenter: permissionCenterTrackingInitializer,
    LeadForm: formTrackingInitializer
};
export const initTracking = (tracker)=>{
    const componentDomElements = getComponentDomElements();
    const componentsToInit = Object.keys(componentDomElements);
    const cleanUpFunctions = componentsToInit.map((componentName)=>TrackingInitializerMap[componentName]?.(tracker));
    return ()=>{
        cleanUpFunctions.map((cleanUpFunction)=>cleanUpFunction?.());
    };
};

//# sourceMappingURL=reactTrackingInitializer.js.map